import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { Link } from '@tanstack/react-router';
import { ChangePasswordForm } from '../components/ChangePasswordForm';
import { getStoredUser } from '@/lib/auth';
import { ROUTES } from '@/lib/constants';
import { UserRole } from '@academia-apolo/shared-types';
const ACCENT_RGB = '56,182,239';
const FG_2 = 'rgba(255,255,255,0.55)';
const FG_3 = 'rgba(255,255,255,0.35)';
const DIVIDER = 'rgba(255,255,255,0.08)';
function homeForStoredUser() {
    const role = getStoredUser()?.role;
    if (role === UserRole.DIRECTOR)
        return ROUTES.DIRECTOR_HOME;
    if (role === UserRole.PROFESSOR)
        return ROUTES.PROFESSOR_HOME;
    return ROUTES.STUDENT_DASHBOARD;
}
export function ChangePasswordPage() {
    const rootRef = useRef(null);
    // Forced flow = temp password on first login; otherwise it's a voluntary change.
    const forced = getStoredUser()?.mustChangePassword ?? false;
    useEffect(() => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !rootRef.current)
            return;
        const ctx = gsap.context(() => {
            gsap.from('[data-anim="cp-eyebrow"], [data-anim="cp-title"], [data-anim="cp-sub"]', {
                opacity: 0, y: 24, duration: 0.9, ease: 'power3.out', stagger: 0.12, delay: 0.1,
            });
            gsap.from('[data-anim="form-field"]', {
                opacity: 0, y: 18, duration: 0.7, ease: 'power3.out', delay: 0.5, stagger: 0.1,
            });
            gsap.from('[data-anim="form-submit"]', {
                opacity: 0, y: 16, duration: 0.7, ease: 'power3.out', delay: 0.85,
            });
        }, rootRef);
        return () => ctx.revert();
    }, []);
    return (_jsx("div", { ref: rootRef, className: "min-h-screen w-full flex items-center justify-center px-6 py-16", style: { background: '#080e1c', color: '#fff' }, children: _jsxs("div", { className: "w-full max-w-md", children: [_jsxs("div", { "data-anim": "cp-eyebrow", className: "flex items-center gap-4 mb-8", children: [_jsx("span", { className: "font-mono font-bold uppercase", style: {
                                fontSize: '10px',
                                letterSpacing: '0.28em',
                                color: `rgba(${ACCENT_RGB},0.85)`,
                            }, children: "Seguridad \u2014\u2014" }), _jsx("span", { className: "flex-1 h-px", style: { background: DIVIDER } }), _jsx("span", { className: "font-mono uppercase", style: { fontSize: '10px', letterSpacing: '0.22em', color: FG_3 }, children: forced ? 'Obligatorio' : 'Tu cuenta' })] }), _jsxs("h1", { "data-anim": "cp-title", className: "font-black tracking-tight leading-[0.94] mb-5", style: { fontSize: 'clamp(1.9rem, 3.2vw, 2.6rem)' }, children: ["Cambia tu", ' ', _jsx("span", { className: "italic font-serif font-normal", style: { color: '#38B6EF' }, children: "contrase\u00F1a" })] }), _jsx("p", { "data-anim": "cp-sub", className: "mb-10 leading-relaxed", style: { color: FG_2, fontSize: '15px' }, children: forced
                        ? 'Por seguridad, debes cambiar tu contraseña temporal antes de acceder a tu panel. Usa una contraseña única que no hayas empleado en otros servicios.'
                        : 'Introduce tu contraseña actual y elige una nueva. Usa una contraseña única que no hayas empleado en otros servicios.' }), _jsx(ChangePasswordForm, {}), !forced && (_jsx("div", { className: "mt-8", children: _jsx(Link, { to: homeForStoredUser(), className: "font-mono uppercase transition-opacity hover:opacity-80", style: { fontSize: '11px', letterSpacing: '0.18em', color: FG_3 }, children: "\u2190 Volver al panel" }) }))] }) }));
}
//# sourceMappingURL=ChangePasswordPage.js.map